import useStore from '@/stores/store';

const useUserProfile = () => {
  return useStore((state) => state.user.profile);
};

export default useUserProfile;
